export var categoryMap = {
    severe: 'severe',
    normal: 'normal',
    mild: 'mild to moderate',
};
var categoryPathMap = {
    severe: 'severe',
    normal: 'normal',
    'mild to moderate': 'mild',
};
export function getCategoryPath(category) {
    if (!category)
        return;
    var isResultCategory = function (category) {
        return Object.values(categoryMap).includes(category);
    };
    if (!isResultCategory(category))
        return;
    return categoryPathMap[category];
}
